<template>
  <div class="wrap">
    <div class="box-top">
      <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="add">新增</el-button>
      <!-- <el-input v-model="mess" placeholder="请输入活动主题查询" @keydown.enter.native="Search" clearable>
        <i slot="prefix" class="el-input__icon el-icon-search" @click="Search"></i>
      </el-input> -->
    </div> 

    <!-- 列表 -->
    <commonTable ref="commonTable" :dataSource="tableData" :columnsList="columns" :total="total" @currentChange="currentChange" @sizeChange="sizeChange">
      <template slot="code" slot-scope="{record}">
        {{record.code}} <span class="iconfont icon-erweima" @click="handleQR(record)"></span>
      </template>
      <template slot="subject" slot-scope="{record}">
        {{subjectContent[record.subject]}}
      </template>
      <template slot="action" slot-scope="{record}">
        <el-button @click="edit(record)" type="text" style="color: #00788b;">编辑</el-button>
        <el-divider direction="vertical"></el-divider>
        <el-popconfirm title="确定删除吗？" @confirm="confirm(record)">
          <el-button slot="reference" type="text" style="color: #b51c1b;">删除</el-button>
        </el-popconfirm>
      </template>
    </commonTable>

    <!-- 弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="100%"
      :fullscreen="true"
      :before-close="handleClose" center :close-on-press-escape="false" :close-on-click-modal="false">
        <study-sign-modal v-if="dialogVisible" ref="exerciseModal" :oldForm="form"></study-sign-modal>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" :size="btnSize">取 消</el-button>
        <el-button type="primary" @click="submit" :size="btnSize">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 二维码弹窗 -->
    <el-dialog :title="qrtitle" :visible.sync="QRVisible" width="30%" :before-close="qrClose" center :close-on-press-escape="false" :close-on-click-modal="false">
      <div class="QRBox">
        <!-- <h2>{{qrtitle}}</h2> -->
        <vue-qr :text="imgUrl" :size="250"></vue-qr>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { exercisesList, addExercises, deleteExercises, updateExercises } from '@/api/exercise';
import studySignModal from './exerciseModal.vue';
import commonTable from '../../components/commonTable.vue';
import { myMixins } from '../../mixins/myMixins';
import VueQr from 'vue-qr';
export default {
  name: 'studySign',
  mixins: [myMixins],
  data() {
    return {
      // id: JSON.parse(sessionStorage.getItem('userInfo')).id || '',
      mess: '',
      total: 0,
      title: '',
      pageNo: 1,
      pageSize: 10,
      imgUrl: '',
      QRVisible: false,
      qrtitle: '',
      btnSize: 'mini',
      dialogVisible: false,
      tableData: [],
      form: {},
      subjectContent: { '1': '一年级', 2: '二年级', 3: '三年级', 4: '四年级', 5: '五年级', 6: '六年级', 7: '初一', 8: '初二', 9: '初三', 10: '高一', 11: '高二', 12: '高三' },
      columns: [
        {
          title: '标题',
          key: 'title',
          align: 'center'
        },
        {
          title: '引言',
          key: 'proverb',
          align: 'center',
          width: 300,
        },
        {
          title: '年级',
          key: 'subject',
          align: 'center',
          // scopedSlots: {
          //   columnSlot: 'subject'
          // }
        },
        {
          title: '二维码',
          key: 'code',
          align: 'center',
          scopedSlots: {
            columnSlot: 'code'
          }
        },
        {
          title: '描述',
          key: 'introduce',
          align: 'center',
          width: 700,
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          scopedSlots: {
            columnSlot: 'action'
          },
          width: 120,
        },
      ]
    }
  },
  components: {
    commonTable,
    studySignModal,
    VueQr
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      let data = {
        // title: this.mess||undefined,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      exercisesList(data).then(res => {
        if(res.success) {
          if(res.result.records.length == 0 && res.result.total != 0) {
            this.pageNo = res.result.pages;
            this.loadData();
          }else {
            this.tableData = res.result.records;
            this.total = res.result.total;
            this.pageNo = res.result.current;
            this.pageSize = res.result.size; 
          }
          this.$nextTick(() => {
            this.$refs.commonTable.$refs.table.doLayout();
          })
        }
      })
    },
    Search() {
      this.pageNo = 1;
      this.loadData();
    },
    submit() {
      this.$refs.exerciseModal.$refs.form.validate((valid) => {
        if(this.$refs.exerciseModal.fileList && this.$refs.exerciseModal.fileList.length > 0) {
          this.$refs.exerciseModal.form.casePicture = '';
          this.$refs.exerciseModal.fileList.forEach((item,index) => {
            if(index == 0) {
              this.$refs.exerciseModal.form.casePicture = item.fileUrl;
            }else {
              this.$refs.exerciseModal.form.casePicture = this.$refs.exerciseModal.form.casePicture + ',' + item.fileUrl;
            }
          })
        }
        let formInfo = this.$refs.exerciseModal.form
        let param = JSON.parse(JSON.stringify(formInfo));
        if(!valid) {
          return 
        }else{
          let request = null;
          if(formInfo.id) {
            request = updateExercises(param);
          }else {
            // param.id = this.id//用户id
            request = addExercises(param)
          }
          request.then(res => {
            if(res.success) {
              this.$message.success(res.message);
              this.dialogVisible = false;
              this.loadData();
            }else {
              this.$message.error(res.message);
            }
          })
        }
      })
    },
    handleClose() {
      this.dialogVisible = false;
    },
    add() {
      this.form = {};
      this.dialogVisible = true;
      this.title = '新增练习题';
    },
    edit(e) {
      this.form = e;
      this.dialogVisible = true;
      this.title = '编辑练习题';
    },
    del(e) {
      deleteExercises({id: e.id}).then(res => {
        if(res.success) {
          this.$message.success(res.message);
          this.loadData();
        }else {
          this.$message.error(res.message);
        }
      })
    },
    confirm(e) {
      this.del(e);
    },
    handleQR(e) {
      // console.log(e);
      // return;
      this.qrtitle = e.title;
      // this.imgUrl = '3,'+e.code;
      this.imgUrl = 'http://www.yuanhuishang.com/yhs/lxt/?code='+e.code;
      this.QRVisible = true;
    },
    qrClose() {
      this.QRVisible = false;
    },
  }
}
</script>

<style scoped lang="less">
  @import '../../assets/css/commonMenu.less';
  .iconfont{
    font-size: 18px;
    color: skyblue;
  }
  .QRBox{
    text-align: center;
  }
</style>